export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const SET_NOTIFICATIONS_PAGE = "SET_NOTIFICATIONS_PAGE";

export const SOCKET_SEND_TOKEN = 'SOCKET_SEND_TOKEN';
export const SOCKET_ON_MESSAGE = 'SOCKET_ON_MESSAGE';

export const getNotifications = values => ({
  type: GET_NOTIFICATIONS,
  payload: {
    page: values && values.page ? values.page : 1,
    ...values
  }
});

export const onSocketSendToken = values => ({
  type: SOCKET_SEND_TOKEN,
  payload: values,
});

export const onSocketMessage = values => ({
  type: SOCKET_ON_MESSAGE,
  payload: values,
});


// WEBPACK FOOTER //
// ./src/redux/actions/notificationActions.js